// src/api/reservation.ts
import api from './axios'; // ✅ 使用封装后的 axios 实例

export interface ReservationData {
  service: string;
  visit_type: string;
  date: string;
  time: string;
  needs_translation?: boolean;
}

export interface ReservationResponse {
  id: number;
  service: string;
  visit_type: string;
  date: string;
  time: string;
  status: string;
  created_at: string;
  zoom_join_url: string | null;
  prescription_url: string | null;
  diagnosis: string | null;
  prescription_text: string | null;
  notes: string | null;
}

export const createReservation = async (
  data: ReservationData
): Promise<ReservationResponse> => {
  try {
    const response = await api.post('/reservations', data);
    return response.data;
  } catch (error: any) {
    // ✅ 直接抛出带 detail 和 status 的对象，方便前端直接取 err.detail
    throw {
      detail: error?.response?.data?.detail || '予約に失敗しました。',
      status: error?.response?.status || 400,
    };
  }
};

export const getReservations = async (): Promise<ReservationResponse[]> => {
  try {
    const response = await api.get('/reservations');
    return response.data;
  } catch (error: any) {
    throw {
      detail: error?.response?.data?.detail || '予約情報の取得に失敗しました。',
      status: error?.response?.status || 400,
    };
  }
};
